import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveFloat32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMoveFloat32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M30.335 18.275a1.2 1.2 0 0 1-1.144 1.255c-1.44.066-2.42-.678-3.057-1.138-.695-.502-1.046-.718-1.555-.7-.464.016-.774.223-1.394.695-.577.438-1.461 1.136-2.798 1.144-1.356.007-2.256-.699-2.842-1.141-.633-.477-.948-.686-1.418-.698-.517-.013-.87.2-1.541.677-.624.445-1.569 1.16-2.961 1.162-1.398.002-2.349-.716-2.976-1.162-.674-.479-1.03-.692-1.547-.677-.468.013-.781.221-1.41.698-.584.442-1.48 1.146-2.83 1.14a1.2 1.2 0 0 1 .01-2.4c.45.002.755-.187 1.37-.653.57-.431 1.456-1.146 2.791-1.184 1.411-.04 2.369.667 3.007 1.121.686.488 1.05.717 1.581.716.53 0 .89-.23 1.572-.715.636-.452 1.588-1.158 2.993-1.123 1.34.034 2.232.75 2.805 1.183.62.468.927.658 1.382.655.45-.002.752-.192 1.36-.654.563-.429 1.44-1.135 2.761-1.183 1.435-.05 2.412.697 3.045 1.154.69.498 1.038.708 1.541.685a1.2 1.2 0 0 1 1.255 1.143m-4.554-5.273a6.2 6.2 0 0 0-2.528.044 7.89 7.89 0 0 0-14.642.02 6.1 6.1 0 0 0-2.516-.085c1.29-4.21 5.208-7.272 9.84-7.272l.53.014c4.407.223 8.082 3.22 9.316 7.28m-.653 7.622a10.29 10.29 0 0 1-9.192 5.666l-.53-.013a10.29 10.29 0 0 1-8.675-5.674c.166-.12.303-.223.405-.3l.04-.03.078.053c.482.342 1.662 1.258 3.39 1.527a7.86 7.86 0 0 0 5.291 2.038 7.86 7.86 0 0 0 5.272-2.02c1.771-.248 2.949-1.212 3.425-1.574l.015-.012.077.052q.155.114.404.287"
            />
        </svg>
    );
}
export default memo(IconMoveFloat32);
